import { AddNote } from './add-note';
import { AddTaxIdentifiers } from './add-tax-identifiers';
import { AdjustWeight } from './adjust-weight';
import { ApplyShippingPreset } from './apply-shipping-preset';
import { Confirmation } from './confirmation';
import { One } from './custom-fields/one';
import { Two } from './custom-fields/two';
import { Three } from './custom-fields/three';
import { CustomsDeclarations } from './customs-declarations';
import { Dimensions } from './dimensions';
import { DutiesAndTaxes } from './duties-and-taxes';
import { EmailTemplate } from './email-template';
import { Insurance } from './insurance';
import { OtherShippingOptions } from './other-shipping-options';
import { Package } from './package';
import { PackingSlipTemplate } from './packing-slip-template';
import { ShipByDate } from './ship-by-date';
import { ShipFrom } from './ship-from';
import { ShippingAccount } from './shipping-account';
import { ShippingService } from './shipping-service';
import { Weight } from './weight';

export const BulkActions = [
  AddNote,
  AddTaxIdentifiers,
  Confirmation,
  One,
  Two,
  Three,
  Dimensions,
  DutiesAndTaxes,
  Package,
  ShipByDate,
  Insurance,
  ShipFrom,
  Weight,
  PackingSlipTemplate,
  EmailTemplate,
  ShippingService,
  OtherShippingOptions,
  ApplyShippingPreset,
  CustomsDeclarations,
  AdjustWeight,
  ShippingAccount,
];
